<!-- src/components/common/SupportBanner.vue -->
<template>
  <div v-if="showBanner" class="alert alert-danger" role="alert">
    <div class="d-flex align-items-center gap-2 flex-wrap">
      <strong class="me-1">브라우저 호환성 안내</strong>
      <span class="badge bg-dark">TEST</span>

      <span v-if="info.family !== 'unknown'">
        현재: {{ getBrowserLabel(info.family) }} {{ info.version ?? "" }}
      </span>

      <span v-if="info.minVersion" class="text-nowrap">
        · 권장 최소: {{ getBrowserLabel(info.family) }} {{ info.minVersion }}+
      </span>

      <span v-if="info.inApp" class="badge bg-secondary ms-1">
        인앱({{ info.inAppName }})
      </span>

      <span class="ms-auto small text-muted">정책: 넓은 호환(Soft Gate)</span>
    </div>

    <ul class="small my-2">
      <li v-if="info.level === 'blocked'">
        필수 기능(Proxy/CSS 변수) 미지원으로 일부 화면이 정상 동작하지 않을 수
        있습니다.
      </li>
      <li v-else>
        공식 지원 범위 밖의 버전입니다. 가능하면 브라우저 업데이트를 권장합니다.
      </li>
    </ul>

    <div class="d-flex gap-2">
      <a
        :href="supportPolicyHref"
        target="_blank"
        rel="noopener"
        class="btn btn-sm btn-outline-secondary"
      >
        지원 범위 보기
      </a>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";

import { useSupportCheck } from "@/composables/useSupportCheck";

import { useRouter, useRoute } from "vue-router";

const router = useRouter();
const route = useRoute();
const { summary } = useSupportCheck();

/* ==============================
 *  정적 데이터
 * ============================== */
const BROWSER_LABELS = {
  chrome: "Chrome",
  edge: "Edge",
  firefox: "Firefox",
  safari: "Safari",
  ios_saf: "iOS Safari",
  opera: "Opera",
  samsung: "Samsung Internet",
  unknown: "Unknown",
};

/* ==============================
 *  Computed
 * ============================== */
const info = computed(
  () => summary.value || { level: "unknown", family: "unknown" }
);

const showBanner = computed(() => info.value.level !== "supported");

const supportPolicyHref = computed(() => {
  try {
    return router.resolve({ name: "support-policy" }).href;
  } catch {
    return "/support-policy";
  }
});

/* ==============================
 *  메서드
 * ============================== */
function getBrowserLabel(family) {
  return BROWSER_LABELS[family] || "Unknown";
}
</script>

<style scoped>
.alert {
  margin: 1rem 0;
}
</style>
